import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Button } from "reactstrap";
import { PresupuestoPlanificacionHistoricoHEDTO } from './TypesPlanificacionHE';
import { ObtenerInformacionHistorialPresupuestoPlanificacionHE } from './FunctionsPlanificacionHE';
import Cargando from 'components/Varios/Cargando';
import { alertService } from 'components/Varios/alert_service';
import CardRegimenHEInicio from './CardRegimenHEInicio';
import { showAlert } from 'components/Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';

import ErrorSVG from "../../../../assets/icons/HorasExtras/Error.svg"

export default function PlanificacionHEInicio() {

    const defaultHistorialPresubpuestoPlanificacion = {
        anio: 0,
        detalleRegimenPresupuestobyMes: []
    }


    const anio = 0;
    const [loading, setloading] = useState<boolean>(false)
    const [historialPresupuestoPlanificacion, sethistorialPresupuesPlanificacion] = useState<PresupuestoPlanificacionHistoricoHEDTO>(defaultHistorialPresubpuestoPlanificacion);

    async function ObtenerInformacionGeneral() {
        setloading(true)
        const informacionGeneral = await ObtenerInformacionHistorialPresupuestoPlanificacionHE(anio);
        if (informacionGeneral.status === 200 && informacionGeneral.dataResponse ) {

            if(typeof informacionGeneral.dataResponse !== 'string') {
                sethistorialPresupuesPlanificacion(informacionGeneral.dataResponse)
            }
            else {  
                sethistorialPresupuesPlanificacion(defaultHistorialPresubpuestoPlanificacion); // 
                showAlert(informacionGeneral.errorMessage??'', true, ErrorSVG)                 
            }
            
        } else {
            sethistorialPresupuesPlanificacion(defaultHistorialPresubpuestoPlanificacion);
            showAlert(informacionGeneral.errorMessage??'', true, ErrorSVG) // Set an empty state
        }
        setloading(false)
    }

    useEffect(() => {
        //ObtenerInformacionGeneral()
        //return () => {
        //    alertService.clear()
        //}
        window.location.href = "https://th.espol.edu.ec/directivo/planificacionhorasextras";
    }, [])

    

    const contenidoCardRegimen = (
        <Row>
            <Col xl={12}>
                <Row>
                    {historialPresupuestoPlanificacion.detalleRegimenPresupuestobyMes.map((regimen, index) => (
                        <Col xl={4} key={index} className="mb-3 same-height-container">
                            <CardRegimenHEInicio
                                anio={historialPresupuestoPlanificacion.anio}
                                nombreMes={regimen.key.nombreMes}
                                numeroMes={regimen.key.numeroMes}
                                puedeRealizarAccion={regimen.key.puedeRealizarAccion?regimen.key.puedeRealizarAccion:false}
                                regimenLaboralPlan={regimen.value}
                                index={index}
                            />
                        </Col>
                    ))}
                </Row>
            </Col>
        </Row>
    );


    const TITULO_PANTALLA = `PLANIFICACIÓN MENSUAL DE HORAS EXTRAS DEL AÑO ${historialPresupuestoPlanificacion.anio}`;

    return (
        <>
        {loading && <Cargando />}
        {!loading && (
            <div className="content">
                <div className="titulo_seccion mb-5"> {TITULO_PANTALLA}</div>               
                {contenidoCardRegimen}
            </div>
        )}
        </>
    )
}